import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Tooltip, Button, Divider, Input, Modal } from "antd";

import {
  req_list_tqa_all_report,
  req_signle_tqa_qaBulletinBoard,
} from "../../api";
import { getNowAcademicYear } from "../../utils/dateUtil";
import { API_BASE } from "../../utils/contrains";
import SchoolQuailtyA01 from "./school-quailty-a01";
import SchoolQuailtyA02 from "./school-quailty-a02";
import SchoolQuailtyA03 from "./school-quailty-a03";
import SchoolQuailtyA04 from "./school-quailty-a04";
import SchoolQuailtyA05 from "./school-quailty-a05";

import ShowCollegeModal from "./show-college-modal";
import ShowDepartmentModal from "./show-department-modal";
import ShowInstituteModal from "./show-institute-modal";

class AllManualIndex extends Component {
  state = {
    academicYear: getNowAcademicYear(new Date()) - 1,
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    domnloadFile: "",
    isShowSchoolModal: false,
    isShowCollegeModal: false,
    isShowDepartmentModal: false,
    isShowInstituteModal: false,
    departments: [],
    colleges: [],
    manualStatus: false,
    manualUrl: "",
  };

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  componentDidMount() {
    this.api_list_all_report();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_list_all_report = async () => {
    this.setState({ loading: true });
    const { academicYear } = this.state;
    const { token } = this.props.user;

    const result = await req_list_tqa_all_report(academicYear, token);
    // console.log(result);
    if (result.total > 0) {
      const colleges = result.data.filter(function (el) {
        return el.WorkTypeCode === "A" || el.WorkTypeCode === "B";
      });
      const departments = result.data.filter(function (el) {
        return el.WorkTypeCode === "C" || el.WorkTypeCode === "D";
      });
      this.setState({ colleges, departments });
    } else {
      this.setState({ colleges: [], departments: [] });
    }
    const manual = await req_signle_tqa_qaBulletinBoard(academicYear, token);
    //console.log(manual);
    if (manual === null) {
      const manualUrl = manual.RecordFileUrl;
      this.setState({ manualStatus: true, manualUrl });
    } else {
      this.setState({ manualStatus: false });
    }

    this.setState({ loading: false });
  };

  api_downloadfile = async (fileUrl) => {
    // download file link
    //console.log(fileUrl);
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };
  // 數據配置設定 //////////////////////////////////////////////
  style_switch_txtcolor_btn(column) {
    let ans = "#ffffff";
    switch (column.charAt(0)) {
      case "A": //生活科技學院
        ans = "#ffffff";
        break;
      case "B": // 管理學院
        ans = "#ffffff";
        break;
      case "C": // 設計學院
        ans = "#ffffff";
        break;
      case "D": // 藝術學院
        ans = "#ffffff";
        break;
      case "E": // 旅遊學院
        ans = "#ffffff";
        break;
      default:
        break;
    }
    return ans;
  }

  style_switch_bgcolor_btn(column) {
    let ans = "#696969";
    switch (column.charAt(0)) {
      case "A": //生活科技學院
        ans = "#acce22";
        break;
      case "B": // 管理學院
        ans = "#0061ae";
        break;
      case "C": // 設計學院
        ans = "#f08519";
        break;
      case "D": // 藝術學院
        ans = "#e40082";
        break;
      case "E": // 旅遊學院
        ans = "#00a098";
        break;
      default:
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_all_report();
  };

  handle_show_ui_modal = (level, departmentCode, departmentName) => {
    const { academicYear, manualUrl } = this.state;
    const item = {
      departmentCode,
      departmentName,
      academicYear,
      AcademicYear: academicYear,
    };
    switch (level) {
      case "SCHOLL_A00": //規章
        this.api_downloadfile(manualUrl);
        break;
      case "SCHOLL_A01":
        this.setState({ isA01Modal: true, item });
        break;
      case "SCHOLL_A02":
        this.setState({ isA02Modal: true, item });
        break;
      case "SCHOLL_A03":
        this.setState({ isA03Modal: true, item });
        break;
      case "SCHOLL_A04":
        this.setState({ isA04Modal: true, item });
        break;
      case "SCHOLL_A05":
        this.setState({ isA05Modal: true, item });
        break;
      case "COLLEGE": //學院及中心
        this.setState({ isShowCollegeModal: true, item });
        break;
      case "C": //學系
        this.setState({ isShowDepartmentModal: true, item });
        break;
      case "D": //研究所
        this.setState({ isShowInstituteModal: true, item });
        break;
      case "DELETE":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "DOWNLOAD":
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      academicYear,
      item,
      colleges,
      departments,
      isShowInstituteModal,
      isShowDepartmentModal,
      isShowCollegeModal,
      isA01Modal,
      isA02Modal,
      isA03Modal,
      isA04Modal,
      isA05Modal,
      manualStatus,
    } = this.state;

    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );

    const college_title =
      colleges.length > 0 ? (
        <Divider orientation="left" plain>
          學院、中心級
        </Divider>
      ) : (
        ""
      );

    const college_content =
      colleges.length > 0
        ? colleges.map((d, idx) => (
            <button
              type="button"
              onClick={() =>
                this.handle_show_ui_modal(
                  "COLLEGE",
                  d.DepartmentCode,
                  d.DepartmentName
                )
              }
              className="btn btn-outline-dark btn-sm"
              style={{
                marginRight: "4px",
                marginBottom: "4px",
                color: this.style_switch_txtcolor_btn(d.DepartmentCode),
                backgroundColor: this.style_switch_bgcolor_btn(
                  d.DepartmentCode
                ),
              }}
              disabled={d.RecordStatus === "DONE" ? false : true}
            >
              {d.DepartmentName}
            </button>
          ))
        : "";

    const department_title =
      departments.length > 0 ? (
        <Divider orientation="left" plain>
          學系、碩班級
        </Divider>
      ) : (
        ""
      );

    const department_content =
      departments.length > 0
        ? departments.map((d, idx) => (
            <button
              type="button"
              onClick={() =>
                this.handle_show_ui_modal(
                  d.WorkTypeCode,
                  d.DepartmentCode,
                  d.DepartmentName
                )
              }
              className="btn btn-outline-dark btn-sm"
              style={{
                marginRight: "4px",
                marginBottom: "4px",
                color: this.style_switch_txtcolor_btn(d.DepartmentCode),
                backgroundColor: this.style_switch_bgcolor_btn(
                  d.DepartmentCode
                ),
              }}
              disabled={d.RecordStatus === "DONE" ? false : true}
            >
              {d.DepartmentName}
            </button>
          ))
        : "";

    return (
      <Card title={title}>
        <Divider orientation="left" plain>
          校級
        </Divider>
        <button
          type="button"
          onClick={() => this.handle_show_ui_modal()}
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={manualStatus}
        >
          教學品質保證制度規範與作業
        </button>
        <button
          type="button"
          onClick={() =>
            this.handle_show_ui_modal("SCHOLL_A01", "1051", "台南應用科技大學")
          }
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={colleges.length > 0 ? false : true}
        >
          A01-校教育目標
        </button>
        <button
          type="button"
          onClick={() =>
            this.handle_show_ui_modal("SCHOLL_A02", "1051", "台南應用科技大學")
          }
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={colleges.length > 0 ? false : true}
        >
          A02-校與各院教育目標
        </button>
        <button
          type="button"
          onClick={() =>
            this.handle_show_ui_modal("SCHOLL_A03", "1051", "台南應用科技大學")
          }
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={colleges.length > 0 ? false : true}
        >
          A03-校學生基本素養
        </button>
        <button
          type="button"
          onClick={() =>
            this.handle_show_ui_modal("SCHOLL_A04", "1051", "台南應用科技大學")
          }
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={colleges.length > 0 ? false : true}
        >
          A04-校學生核心能力
        </button>
        <button
          type="button"
          onClick={() =>
            this.handle_show_ui_modal("SCHOLL_A05", "1051", "台南應用科技大學")
          }
          className="btn btn-outline-dark btn-sm"
          style={{
            marginRight: "4px",
            marginBottom: "4px",
            color: "#ffffff",
            backgroundColor: "#9932CC",
          }}
          disabled={colleges.length > 0 ? false : true}
        >
          A05-校與各院核心能力關聯
        </button>
        <Modal
          destroyOnClose={true}
          visible={isA01Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA01Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA01Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA01 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA02Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA02Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA02Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA02 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA03Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA03Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA03Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA03 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA04Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA04Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA04Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA04 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA05Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA05Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA05Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA05 manual={item} />
        </Modal>

        {college_title}
        {college_content}
        {department_title}
        {department_content}
        <Modal
          destroyOnClose={true}
          visible={isShowCollegeModal}
          width={"600px"}
          onOk={() => {
            this.setState({ isShowCollegeModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowCollegeModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ShowCollegeModal item={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowDepartmentModal}
          width={"800px"}
          onOk={() => {
            this.setState({ isShowDepartmentModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowDepartmentModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ShowDepartmentModal item={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowInstituteModal}
          width={"800px"}
          onOk={() => {
            this.setState({ isShowInstituteModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowInstituteModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ShowInstituteModal item={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AllManualIndex);
